import { parse } from 'odata-v4-filter-parser';
import _ from 'underscore';
import { startsWith } from 'underscore.string';

export function getQueryPart(queryString, partPrefix) {
  const part = _.find(queryString.split('&'), frag => startsWith(frag, partPrefix));

  return part ? part.substr(partPrefix.length) : null;
}

const selectPrefix = '$select=';

export function getPropertiesFromQueryString(queryString) {
  return getQueryPart(queryString, selectPrefix)
    .split(',');
}

const filterPrefix = '$filter=';
export function getFilterFromQueryString(queryString) {
  const filterPart = getQueryPart(queryString, filterPrefix);

  return filterPart ?
    parse(decodeURIComponent(filterPart)) :
    null;
}
